module.exports = __webpack_public_path__ + "img/posterbg-meeting.b126c57a.png";